<template>
  <b-container>
    <b-row>
      <b-col>
        <Multiselect class="pt-1 pb-1"
                     :items="multiSelectItems"
                     v-model="multiselectSelected"
                     :readOnly="multiSelectReadOnly"
                     :allow-add="true"
                     @item-removed="updVals"
        >
        </Multiselect>
      </b-col>
    </b-row>
    <b-row class="pt-5">
      <b-col>
        <b-checkbox v-model="multiSelectReadOnly">{{$tr('readOnly','ReadOnly')}}</b-checkbox>
      </b-col>
      <b-col>
        <b-btn @click="addMultiSelectItem">{{$tr('multiSelect.addItem','Add item')}}</b-btn>
      </b-col>
    </b-row>
    <b-row>
      <b-col v-for="i in multiselectSelected" :key="i.value">
        {{ i }}
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Multiselect from "@/components/inputs/controls/Multiselect";

export default {
  name: "MultiselectTest",
  components: {Multiselect},
  methods:{

    addMultiSelectItem(){
      this.multiSelectItems.push("Item" + Math.random());
    },

    updVals(item) {
      this.multiselectSelected =
          typeof item === 'string' || item instanceof String ?
              this.multiselectSelected = this.multiselectSelected.filter(x => x != item) :
              this.multiselectSelected = this.multiselectSelected.filter(x => x != item.value);
    }
  },

  watch: {
    "validatedField.value": function (newVal, oldVal) {
    },
  },

  data:() => {
    return {
      multiSelectItems: [{value:"Item1", text:"Item1"}, {value:"ItemXY", text:"ItemXY"}, {value:0, text:"Item multiple words"},
        {value:"ItemX2", text:"ItemX2"},
        {value:"ItemX3", text:"ItemX3"}],
      multiselectSelected: ["Item1", "ItemXY"],
      multiSelectReadOnly: true,
    }
  }
}
</script>
